import type { NudgeRecommendationDetails } from '@atlassian/convo-ai-api/convo-api';

import type { MigratedBaseConversationAction } from '../types';
import { enrichConversationStarterNudge } from './enrichConversationStarterNudge';

/**
 * Enriches a matched nudge with BE recommendation data when needed.
 * For nudges whose content is driven by the BE (e.g. convo starters), the label
 * and prompt are filled in from the recommendation payload at match time.
 * For all other nudge types, the nudge is returned as-is.
 * Returns undefined if enrichment fails (e.g. missing required BE data).
 */
export const enrichNudge = (
	nudge: MigratedBaseConversationAction,
	recommendation: NudgeRecommendationDetails,
): MigratedBaseConversationAction | undefined => {
	if (nudge.type === 'convo-starter-action') {
		const enriched = enrichConversationStarterNudge(recommendation);
		if (!enriched) {
			return undefined;
		}
		return { ...enriched, recommendationNudgeId: nudge.recommendationNudgeId };
	}

	return nudge;
};
